"use client";

import React, { createContext, useContext, useState } from "react";

export interface AssignmentHeaderData {
  title?: string;
  progress?: { done: number; total: number };
  status?: string;
}

interface Ctx {
  data: AssignmentHeaderData;
  setData: (d: AssignmentHeaderData) => void;
}

const AssignmentHeaderContext = createContext<Ctx | null>(null);

export const AssignmentHeaderProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [data, setData] = useState<AssignmentHeaderData>({});

  return (
    <AssignmentHeaderContext.Provider value={{ data, setData }}>
      {children}
    </AssignmentHeaderContext.Provider>
  );
};

export const useAssignmentHeader = () => {
  const ctx = useContext(AssignmentHeaderContext);
  if (!ctx) throw new Error("useAssignmentHeader must be used within Provider");
  return ctx;
};
